import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';

export default function Ajuda() {
  const contatos = [
    { icon: <Phone size={32} />, label: 'Policlínica (Ramal 01)', link: 'tel:+551727861140' },
    { icon: <MessageCircle size={32} className="text-[#25D366]" />, label: 'José Antônio (Secretário de Apoio)', link: 'https://wa.me/5518996794681' }
  ];

  return (
    <div className="max-w-auto mx-auto py-12 px-4">
      <h1 className="text-3xl font-bold text-center mb-2">Entre em contato conosco</h1>
      <p className="text-center text-sm text-gray-600 mb-8">
        Horário de atendimento:<br/>
        Segunda a Sexta: 08:00 às 12:00 e 13:00 às 22:00
      </p>

      {/* Ajustei o grid para centralizar melhor já que agora são apenas 2 cards */}
      <div className="flex flex-wrap justify-center gap-6">
        {contatos.map((c, i) => (
          <a
            key={i}
            href={c.link}
            target={c.link.startsWith('http') ? '_blank' : '_self'}
            rel="noopener noreferrer"
            className="flex flex-col items-center justify-center p-6 bg-white rounded-2xl shadow hover:shadow-md transition w-40 sm:w-48"
          >
            <div className="mb-3">{c.icon}</div>
            <span className="text-center text-sm font-medium text-gray-800">{c.label}</span>
          </a>
        ))}
      </div>
    </div>
  );
}